import React from 'react';
import { motion } from 'framer-motion';
import MyBetsHistory from '../betting/MyBetsHistory';

const StyledBettingWrapper = () => {
  return (
    <div className="space-y-4">
      {/* Override the default betting history styles */}
      <style>{`
        /* Override betting history container styles */
        .bg-gray-900,
        .bg-gray-800,
        .bg-slate-900,
        .bg-slate-800 {
          background: transparent !important;
        }

        /* Stats cards */
        .bg-gradient-to-br {
          background: rgba(255, 255, 255, 0.03) !important;
          backdrop-filter: blur(4px) !important;
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
          border-radius: 8px !important;
        }

        /* Table styles */
        .bg-gray-800\\/50 {
          background: rgba(255, 255, 255, 0.02) !important;
          backdrop-filter: blur(4px) !important;
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
        }

        /* Table rows */
        .hover\\:bg-gray-700\\/50:hover {
          background: rgba(255, 255, 255, 0.03) !important;
          border-color: rgba(255, 255, 255, 0.08) !important;
        }

        /* Headers */
        .bg-gray-700\\/50 {
          background: rgba(255, 255, 255, 0.02) !important;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
        }

        /* Text colors */
        .text-gray-400 {
          color: rgba(255, 255, 255, 0.5) !important;
        }

        .text-gray-500 {
          color: rgba(255, 255, 255, 0.3) !important;
        }

        .text-gray-300 {
          color: rgba(255, 255, 255, 0.7) !important;
        }

        /* Status colors */
        .text-green-400,
        .text-green-500 {
          color: rgba(16, 185, 129, 0.8) !important;
        }

        .bg-green-500\\/20 {
          background: rgba(16, 185, 129, 0.1) !important;
        }

        .text-red-400,
        .text-red-500 {
          color: rgba(239, 68, 68, 0.7) !important;
        }

        .bg-red-500\\/20 {
          background: rgba(239, 68, 68, 0.1) !important;
        }

        .text-yellow-400,
        .text-yellow-500 {
          color: rgba(251, 191, 36, 0.7) !important;
        }

        .bg-yellow-500\\/20 {
          background: rgba(251, 191, 36, 0.1) !important;
        }

        /* Buttons */
        button.bg-blue-600,
        button.bg-indigo-600 {
          background: linear-gradient(to right, rgba(16, 185, 129, 0.8), rgba(139, 92, 246, 0.8)) !important;
          backdrop-filter: blur(8px) !important;
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
          border-radius: 6px !important;
        }

        button.bg-blue-600:hover,
        button.bg-indigo-600:hover {
          background: linear-gradient(to right, rgb(16, 185, 129), rgb(139, 92, 246)) !important;
        }

        /* Secondary buttons */
        button.border-gray-600,
        button.bg-gray-700 {
          background: rgba(255, 255, 255, 0.02) !important;
          backdrop-filter: blur(4px) !important;
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
          border-radius: 6px !important;
        }

        button.border-gray-600:hover,
        button.bg-gray-700:hover {
          background: rgba(255, 255, 255, 0.03) !important;
          border-color: rgba(255, 255, 255, 0.08) !important;
        }

        /* Input fields */
        input.bg-gray-700,
        select.bg-gray-700 {
          background: rgba(255, 255, 255, 0.02) !important;
          backdrop-filter: blur(4px) !important;
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
          border-radius: 6px !important;
          color: rgba(255, 255, 255, 0.8) !important;
        }

        input:focus,
        select:focus {
          background: rgba(255, 255, 255, 0.03) !important;
          border-color: rgba(16, 185, 129, 0.3) !important;
          outline: none !important;
        }

        /* Pagination */
        .bg-gray-700 {
          background: rgba(255, 255, 255, 0.02) !important;
        }

        /* Loading spinner */
        .animate-spin {
          color: rgba(16, 185, 129, 0.8) !important;
        }

        /* Rounded corners fix */
        .rounded-2xl,
        .rounded-xl {
          border-radius: 8px !important;
        }

        .rounded-lg {
          border-radius: 6px !important;
        }

        .rounded-md {
          border-radius: 6px !important;
        }

        /* Remove heavy shadows */
        .shadow-2xl,
        .shadow-xl,
        .shadow-lg {
          box-shadow: none !important;
        }

        /* Mobile responsive adjustments */
        @media (max-width: 768px) {
          .text-sm {
            font-size: 12px !important;
          }

          .text-xs {
            font-size: 10px !important;
          }
        }
      `}</style>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <MyBetsHistory />
      </motion.div>
    </div>
  );
};

export default StyledBettingWrapper;